// Firm section — internal financial command surface for the firm.
// Sub-routes:
//   /firm           Dashboard
//   /firm/pl        P&L View
//   /firm/scenarios Scenario Planner
//   /firm/cash-flow Cash Flow

import SectionLayout from '../../components/common/SectionLayout';

const ITEMS = [
  { to: '/firm', label: 'Dashboard', end: true },
  { to: '/firm/pl', label: 'P&L View' },
  { to: '/firm/scenarios', label: 'Scenario Planner' },
  { to: '/firm/cash-flow', label: 'Cash Flow' },
  { to: '/firm/profit-first', label: 'Profit First' },
];

export default function FirmSection() {
  return <SectionLayout title="Firm" items={ITEMS} />;
}
